import SingleProblem from './SingleProblem';

export default SingleProblem;
